import React from "react";
import { useTranslation } from "react-i18next";

import { Button, TitleH2, TitleH4 } from "components/generic";
import { PublishGrid } from "./styles";
import { HOST_PROFILE_EDIT_ROUTE } from "utils/constants";
import { useHospiNavigate } from "../../../utils/common";

export const DialogPublish: React.FC<{
  requestPublish: Function;
  isVerified: boolean;
  isProfileCompleted: boolean;
  notProvidedFields: string[];
}> = ({
  requestPublish,
  isProfileCompleted,
  isVerified = true,
  notProvidedFields
}) => {
  const { t } = useTranslation("hostrooms");
  const navigate = useHospiNavigate();
  if (!isProfileCompleted)
    return (
      <PublishGrid>
        <TitleH2>{t(`publishRequest.title`)}</TitleH2>
        <TitleH4>{t(`publishRequest.notCompletedProfile.text`)}</TitleH4>
        <ul>
          {notProvidedFields.map((field, index) => (
            <li key={index}>{t(`fields.${field}`)}</li>
          ))}
        </ul>
        <div>
          <Button normal onClick={() => requestPublish(false)}>
            {t(`publishRequest.buttons.3`)}
          </Button>
          <Button
            main
            onClick={() => {
              navigate(HOST_PROFILE_EDIT_ROUTE);
            }}
          >
            {t(`publishRequest.buttons.2`)}
          </Button>
        </div>
      </PublishGrid>
    );

  return (
    <PublishGrid>
      <TitleH2>{t(`publishRequest.title`)}</TitleH2>
      <TitleH4>
        {t(`publishRequest.${isVerified ? "text" : "textWarning"}`, {
          joinArrays: "\n\n"
        })}
      </TitleH4>
      {isVerified ? (
        <div>
          <Button normal onClick={() => requestPublish(false)}>
            {t(`publishRequest.buttons.0`)}
          </Button>
          <Button main onClick={() => requestPublish(true)}>
            {t(`publishRequest.buttons.1`)}
          </Button>
        </div>
      ) : (
        <div>
          <span />
          <Button
            main
            onClick={() => {
              navigate(HOST_PROFILE_EDIT_ROUTE);
            }}
          >
            {t(`publishRequest.buttons.2`)}
          </Button>
        </div>
      )}
    </PublishGrid>
  );
};
